module.exports = __webpack_public_path__ + "static/media/2020-02-13 coding-standards.5cf2a97f.md";